// extracted by mini-css-extract-plugin
export default {"photo_name":"Navbar_photo_name__T3sL2"};